import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Renders the list of banners for a specific slot (managed via the admin
 * "Slot Banners" panel). Each banner is a clickable image opening the
 * partner site in a new tab. Renders nothing when the slot has no banners.
 */
export default function SlotBanner({ slot, testId, pair = false }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/slot-banners/${slot}`)
      .then(({ data }) => setItems(Array.isArray(data) ? data : []))
      .catch(() => setItems([]));
  }, [slot]);

  if (!items.length) return null;

  if (pair) {
    return (
      <div
        data-testid={testId || `slot-banner-${slot}`}
        className="grid grid-cols-2 gap-3 sm:gap-4 justify-items-center"
      >
        {items.map((b) => (
          <a
            key={b.id}
            href={b.link_url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`${testId || `slot-banner-${slot}`}-item-${b.id}`}
            className="block w-full max-w-[420px] aspect-[420/80] rounded-md overflow-hidden ring-1 ring-white/10 hover:ring-gold-500 transition-all"
            aria-label={b.title}
            title={b.title}
          >
            <img
              src={b.image_url}
              alt={b.title}
              width={420}
              height={80}
              loading="lazy"
              className="block w-full h-full object-cover"
            />
          </a>
        ))}
      </div>
    );
  }

  return (
    <div
      data-testid={testId || `slot-banner-${slot}`}
      className="w-full flex flex-wrap items-center justify-center gap-3 sm:gap-4 py-4"
    >
      {items.map((b) => (
        <a
          key={b.id}
          href={b.link_url}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`${testId || `slot-banner-${slot}`}-item-${b.id}`}
          className="block rounded-md overflow-hidden ring-1 ring-ink-200 hover:ring-gold-500 transition-all"
          style={{ width: "190px", height: "45px" }}
          aria-label={b.title}
          title={b.title}
        >
          <img
            src={b.image_url}
            alt={b.title}
            width={190}
            height={45}
            loading="lazy"
            draggable={true}
            className="block w-full h-full object-cover"
          />
        </a>
      ))}
    </div>
  );
}
